import React from 'react';
import withShipment from "../../withShipment";
import ErrorFeedbackBar from "../global/ErrorFeedbackBar";
import {PRODUCT_COST_PAGES} from "./constants";
import ProductCostTable from "./ProductCostsPages/ProductCostsTable";

import {listProductCosts} from "../../redux/actions/productCosts";
import PropTypes from "prop-types";
import {productCostsSelector} from "../../redux/selectors/productCosts";
import { getCompany, updateCompany } from '../../redux/actions/automationRules';
import { automationInfoSelector } from '../../redux/selectors/account';
import { userInfoSelector } from '../../redux/selectors/auth';

class ProductCosts extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: PRODUCT_COST_PAGES.TABLE,
        }
    }

    componentDidMount() {
        this.props.listProductCosts()
        this.props.getCompany()
    }

    setCurrentPage = (newPage) => {
        this.setState({
            currentPage: newPage,
        })
    }

    displayTable = () => {
        return <React.Fragment>
            <ProductCostTable
                productCosts={this.props.productCosts}
                setCurrentPage={this.setCurrentPage}
                automationSettings={this.props.automationSettings}
                updateCompany={this.props.updateCompany}
                user={this.props.user}
            />
        </React.Fragment>
    }

    displayCurrentPage = (currentPage) => {
        switch (currentPage) {
            case PRODUCT_COST_PAGES.TABLE:
                return this.displayTable()
            default:
                console.log("Error: current product cost page doesn't exist")
                return <div>We encountered an error. Please refresh the page.</div>
        }
    }

    render() {
        return (
            <React.Fragment>
                <ErrorFeedbackBar/>
                {this.displayCurrentPage(this.state.currentPage)}
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => ({
    productCosts: productCostsSelector(state),
    automationSettings: automationInfoSelector(state),
    user: userInfoSelector(state),
})

const actionCreators = {
    listProductCosts,
    getCompany,
    updateCompany,
}
ProductCosts.propTypes = {
    productCosts: PropTypes.array,
}

ProductCosts.defaultProps = {
    productCosts: [],
}
export default withShipment({
    mapStateToProps,
    actionCreators
}, ProductCosts);